import React, { useEffect, useContext, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';

function PagesLogin() {
	const context = useContext(AppSettings);
	const [redirect, setRedirect] = useState(false);
	
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentClass('p-0');
		
		return function cleanUp() {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentClass('');
		};
		
		// eslint-disable-next-line
	}, []);
	
	function handleSubmit(event) {
		event.preventDefault();
		
		setRedirect(true);
  }
  
	if (redirect) {
		return <Navigate to='/' />;
	}
	return (
		<div className="login">
			<div className="login-content">
				<form onSubmit={handleSubmit}>
					<h1 className="text-center">Sign In</h1>
					<div className="text-body text-opacity-50 text-center mb-5">
						For your protection, please verify your identity.
					</div>
					<div className="mb-4">
						<label className="form-label" htmlFor="">Email Address</label>
						<input type="text" className="form-control form-control-lg fs-14px" defaultValue="" placeholder="username@address.com" />
					</div>
					<div className="mb-4">
						<div className="d-flex">
							<label className="form-label" htmlFor="">Password</label>
							<a href="#/" className="ms-auto text-body text-opacity-50">Forgot password?</a>
						</div>
						<input type="password" className="form-control form-control-lg fs-14px" defaultValue="" placeholder="Enter your password" />
					</div>
					<div className="mb-4">
						<div className="form-check">
							<input className="form-check-input" type="checkbox" defaultValue="" id="customCheck1" />
							<label className="form-check-label fw-500" htmlFor="customCheck1">Remember me</label>
						</div>
					</div>
					<button type="submit" className="btn btn-theme btn-lg d-block w-100 mb-3">SIGN IN</button>
					<div className="text-center text-body text-opacity-50">
						Don't have an account yet? <Link to="/pages/register">Sign up</Link>.
					</div>
				</form>
			</div>
		</div>
	)
}

export default PagesLogin;